<template>
  <div id="StudentModuleProgressPage" ref="whole_page"> 
      <div class="relative h-full">
        <div v-if="!newUIProp" class="key-container">
          <vx-card class="w-full mb-6">
            <div class="key-items">
              <span><feather-icon style="transform: translateY(7px);" class="pt-2" icon="CheckCircleIcon" color="success" svg-classes="stroke-success"></feather-icon>Complete</span>
              <span><feather-icon style="transform: translateY(7px);" class="pt-2" icon="ClockIcon" svg-classes="stroke-warning"></feather-icon>In Progress</span>
              <span><feather-icon style="transform: translateY(7px);" class="pt-2" icon="AlertTriangleIcon" svg-classes="stroke-danger"></feather-icon>Action Required</span>
            </div>
          </vx-card>
        </div>
        <!-- Courses -->
        <div v-if="newUIProp">
            <!--Broken Tasks-->
          <div v-for="(_course, index) in courseList" :key="index" class="mb-3">
            <div style="border-radius: 30px; background-color: rgba(0,0,0,0.5);" class="mb-3 light-gray-border border-3px">
              <div class="vx-row" style="padding: 1.5rem">
                <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
                  <div class="vx-row cursor-pointer" @click="showActionableTasksForCourse(_course)">
                    <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                      <feather-icon icon="BookIcon" class="text-white" svg-classes="stroke-current h-12 w-12"></feather-icon>
                    </div>
                    <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                      <div class="vx-row">
                        <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                          <p class="mb-1 font-white" style="font-size: 2.1rem;font-weight: 600;letter-spacing: -2px;line-height: 1.2;">{{_course.courseName}}</p>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                          <h5 v-if="_course.courseComplete && !_course.actionNeeded" style="color: rgba(var(--vs-success),1)">Complete</h5>
                          <h5 v-if="!_course.courseComplete && !_course.actionNeeded" style="color: rgba(var(--vs-warning),1)">In Progress</h5>
                          <h5 v-if="_course.actionNeeded" style="color: rgba(var(--vs-danger),1)">Action Required</h5>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                      <feather-icon v-if="_course.courseComplete && !_course.actionNeeded" icon="CheckCircleIcon" svg-classes="stroke-success h-12 w-12"></feather-icon>
                      <feather-icon v-if="!_course.courseComplete && !_course.actionNeeded" icon="ClockIcon" svg-classes="stroke-warning h-12 w-12"></feather-icon>
                      <feather-icon v-if="_course.actionNeeded" icon="AlertTriangleIcon" svg-classes="stroke-danger h-12 w-12"></feather-icon>
                    </div>
                  </div>
                  <div v-if="_course.actionNeeded && selectedCourseId == _course.courseId" class="vx-row">
                    <div class="vx-col w-full">
                      <!-- Modules in Course -->
                      <vs-divider><h5>Modules</h5></vs-divider>
                      <div v-if="showLoadingForModules">
                        <custom-skeleton size="medium" :count="5" />
                      </div>
                      <div v-else>
                        <div v-for="(modules,modulesIndex) in progressPopupData.filter(x=>x.courseId == _course.courseId)" :key="modulesIndex">
                          <!-- Module -->
                          <div class="light-gray-border border-3px module-item mb-3 p-3">
                            <div class="vx-row">
                              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                                <feather-icon icon="GridIcon" class="text-white" svg-classes="stroke-current h-6 w-6"></feather-icon>
                              </div>
                              <div class="vx-col w-4/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                                <div class="vx-row">
                                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                                    <p class="font-white" style="font-size: 1.3rem;font-weight: 500;line-height: 1.2;">{{modules.moduleName}}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Tasks for modules -->
                            <vs-divider><h6>Tasks</h6></vs-divider>
                            <div v-if="modules.courseProgressTasks">
                              <div v-for="(task,taskindex) in modules.courseProgressTasks" :key="taskindex">
                                <div v-if="task.taskName.length == 0" class="action-task item-border-green" @click="openTaskAction(task)" >N/A</div>
                                <div v-else class="action-task item-border-green" @click="openTaskAction(task)" >
                                  <!-- {{task.taskDisplayId +" : "+ task.taskName}} -->
                                  <div class="vx-row">
                                    <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                                      <p class="font-white" style="font-size: 1rem;">{{task.displayId}}</p>
                                    </div>
                                    <div class="vx-col w-4/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                                      <div class="vx-row">
                                        <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                                          <p class="font-white" style="font-size: 1rem;">{{task.taskName}}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Logbooks -->
                            <div v-if="modules.logBooks">
                              <vs-divider><h6>Logbook for Module</h6></vs-divider>
                              <div v-for="(logbook,logbookIndex) in modules.logBooks" :key="logbookIndex" class="action-task item-border-green" @click="showLogbookPreviewPopUp(logbook.logBookId)">
                                <div class="vx-row">
                                  <div class="vx-col w-full center-v-h" style="padding-left: 0; padding-right: 0;">
                                    <p class="font-white" style="font-size: 1rem;">Click to sign Logbook</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="modules.assessmentFeedbacks">
                              <vs-divider><h6>Assessor Feedback for Module</h6></vs-divider>
                              <div v-for="(assessmentFeedback,assessmentFeedbackIndex) in modules.assessmentFeedbacks" :key="assessmentFeedbackIndex" class="action-task item-border-green" @click="htmlBuilderForassessorFeedbackDocumentQuestions(assessmentFeedback.assessorFeedbackId)">
                                <div class="vx-row">
                                  <div class="vx-col w-full center-v-h" style="padding-left: 0; padding-right: 0;">
                                    <p class="font-white" style="font-size: 1rem;">Click to sign Assessor Feedback</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <!--Broken Tasks-->
          <div v-if="brokenTaskList.length" class="brokenTaskListRedo">
            <h3>Rewrite</h3>
            <div class="quesListBroken">
              <div v-for="(brokenTask, brokenIndex) in brokenTaskList" :key="brokenIndex">
                <vs-button style="margin-top:4px;margin-bottom:4px;padding:3px" @click="goToTask(brokenTask)" >{{brokenTask.displayId +" : "+ brokenTask.name}}</vs-button>

              </div> 
            </div>
          </div>
          <div class="progress-data" v-for="(course,courseIndex) in courseList" :key="courseIndex" >
            <vx-card v-if="progressPopupData.filter(x=>x.courseId == course.courseId).some(c=>c.actionNeeded)" class="card_small mb-2">
              <vs-collapse  class="w-full" >
                <vs-collapse-item icon-arrow="none" class="w-full">
                  <div class="progressPopup" slot="header">
                    <h6 class="progressHeading mb-0" style="align-self:center">{{ course.courseName }}</h6>
                    <vs-spacer/>
                    <div style="align-self: center;">
                      <span v-if="progressPopupData.filter(x=>x.courseId == course.courseId).some(c=>c.actionNeeded)"><feather-icon class="pt-2" icon="AlertTriangleIcon" svg-classes="stroke-danger"></feather-icon></span>
                      <span v-else-if="!course.courseComplete && !progressPopupData.filter(x=>x.courseId == course.courseId).some(c=>c.actionNeeded)"><feather-icon class="pt-2" icon="ClockIcon" svg-classes="stroke-warning"></feather-icon></span>
                      <span v-else-if="course.courseComplete && !progressPopupData.filter(x=>x.courseId == course.courseId).some(c=>c.actionNeeded)"><feather-icon class="pt-2" icon="CheckCircleIcon" color="success" svg-classes="stroke-success"></feather-icon></span>
                    </div>
                  </div>
                  <div >
                    <div>
                      
                      <vx-card class="vs-popup module-item"  v-for="(moduleItem,modulesIndex) in progressPopupData.filter(x=>x.courseId == course.courseId && x.actionNeeded)" :key="modulesIndex">
                        <h6 style="padding-top:10px; text-align:center !important"><b>Module:</b> {{moduleItem.moduleName}}</h6>
                        
                        
                        <div v-if="moduleItem.courseProgressTasks">
                          <h6 style="text-align: center;" >Tasks for this module</h6>

                          <div style="text-align: center;" v-for="(task,taskindex) in moduleItem.courseProgressTasks" :key="taskindex">
                            <vs-button style="margin-top:4px;margin-bottom:4px;padding:3px" @click="openTaskAction(task)" >{{task.displayId +" : "+ task.taskName}}</vs-button>
                            <div v-if="task.taskName.length == 0" class="action-task">
                              <vs-button style="margin-top:4px;margin-bottom:4px;padding:3px" @click="openTaskAction(task)" >N/A</vs-button>
                            </div>
                          </div>
                        </div>
                        
                        <div v-if="moduleItem.logbooks">
                          <h6 >Logbooks for this module:</h6>
                          <vs-button v-for="(logbook, logbookIndex) in moduleItem.logbooks" :key="logbookIndex" style="margin-top:4px;margin-bottom:4px;padding:3px" @click="showLogbookPreviewPopUp(logbook.logBookId)" >Click to sign logbook</vs-button>
                        </div>

                        <div style="text-align:center !important" v-if="moduleItem.assessmentFeedbacks">
                          <h6 >Assessor Feedback for this module:</h6>
                          <vs-button v-for="(assessorDoc, assessorDocIndex) in moduleItem.assessmentFeedbacks" :key="assessorDocIndex" style="margin-top:4px;margin-bottom:4px;padding:3px" @click="htmlBuilderForassessorFeedbackDocumentQuestions(assessorDoc.assessorFeedbackId)" >Click to sign Assessor Feedback</vs-button>
                        </div>
                        
                      </vx-card>
                    </div>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </vx-card>
            <vx-card v-if="!course.courseComplete && !course.actionNeeded" @click="selectedCourseHandler(course)" class="mb-2" style="cursor:pointer;">
              <div class="progressPopup" >
                <h6 class="progressHeading mb-0" style="align-self:center">{{ course.courseName }}</h6>
                <vs-spacer class=""/>
                <div style="align-self: center;">           
                  <span v-if="!course.courseComplete && !course.actionNeeded"><feather-icon class="pt-2" icon="ClockIcon" svg-classes="stroke-warning"></feather-icon></span>
                </div>
              </div>
            </vx-card>

            <vx-card v-if="course.courseComplete && !course.actionNeeded && !progressPopupData.filter(x=>x.courseId == course.courseId && x.actionNeeded).length" class="mb-2" >
              <div  class="w-full" >
                <div class="w-full">
                  <div class="progressPopup" slot="header">
                    <h6 class="progressHeading mb-0" style="align-self:center">{{ course.courseName }}</h6>
                    <vs-spacer class=""/>
                    <div style="align-self: center;">
                      <span v-if="course.courseComplete && !course.actionNeeded"><feather-icon class="pt-2" icon="CheckCircleIcon" color="success" svg-classes="stroke-success"></feather-icon></span>
                    </div>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>

      <vs-popup
        id="logbook-preview-popup"
        title="Logbook Preview"
        :active.sync="showLogbookPreview"
        fullscreen
      >
      <div v-if="true" class="vx-row">
        <div class="vx-col w-full">
          <div id="html-content" v-html="logbookHtml"></div>
          <div class="vx-row mt-3">
            <vs-spacer />
            <div class="vx-col">
              <vs-button @click="approveLogbook" ref="approve_logbook_btn" class="vs-con-loading__container" color="success">Sign Logbook</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup fullscreen title="Assessor Feedback Preview" id="AssessorFeedbackDocument" :active.sync="assessorfeedbackPopup">
      <div class="assessorFeedbackSize" style="width: fit-content; margin: auto;">
        <assessorFeedbackDocument v-if="assessorfeedbackPopup" :isStudent="true" :assessorFeedbackData="assessorFeedbackData" :taskResults="taskResults" :questionList="questionList" :assessorFeedback="assessorFeedback" @closeAssessorFeedbackDocument="assessorfeedbackPopup = false" />
      </div>
    </vs-popup>

    <vs-popup id="quizViewPopup" title="" :active.sync="quizViewIsActive" @close="handlePopupClose">
      <quiz-view :isCardActive="quizViewIsActive" :quizProp="quiz" @closePopup="closePopup" @refreshTasks="removeSelectedTask" :popupXBtnClicked="popupXBtnClicked" @postEndLog="postEndLog" />
    </vs-popup>
  </div>
</template> 


<script>
import assessorFeedbackDocument from "../../../views/components/AssessorFeedbackDocument.vue";
import quizView from '../QuizView.vue';
import 'animate.css';
export default {
  data() {
    return { 
      quizViewIsActive: false,
      quiz: {},
      popupXBtnClicked: false,
      logbookHtml:'',
      showLogbookPreview:false,
      selectedLogbook:0,
      assessorfeedbackPopup:false,
      selectedCourseId: null,
      assessorFeedbackData:{},
      taskResults:{},
      questionList:[],
      assessorFeedbackDocument:false,
      selectedFeedbackId:0,
      assessorFeedback:{
        studentId:0,
        isCompetent:false,
        hasCompletedQuizzes:false,
        hasCompletedJournals:false,
        hasCompletedLogbook:false,
        hasCompletedPersonalInfo:false,
        hasCompletedAssessmentPrep:false,
        hasCompletedAssessmentPlan:false,
        hasCompletedDeclarationofAuth:false,
        logId:0,
        assessorFeedbackAnswers:[]
      },
      courseList:[],
      brokenTaskList:[],
    }
  },
  components:{ 
    assessorFeedbackDocument,
    quizView
  },
  props: {
    progressPopupData:{
      required:true,
    },
    allModules:{
      required:false,
    },
    currentStudentId:{
      required:true,
    },
    logbooksForModules:{
      required:false,
    },
    courseProgressStucture:{
      required:true
    },
    newUIProp: {
      type: Boolean,
      required: false
    },
    showLoadingForModules: {
      type: Boolean,
      required: false
    },
    isActive: {
      type: Boolean,
      required: false
    }

  },
  watch:{
    isActive: function(val){
      if(val){
        this.courseList = [...new Map(this.progressPopupData.map((item) => [item["courseName"], item])).values(),];
        this.brokenTasks();
      }
    }
  },
  methods: {
    postEndLog(payload) {
      var self = this;
      var onSuccess = function (response) {

      };
      self.$ajaxPost(self, "QuizTask/EndLogEntryByClosingPopup", payload, onSuccess);
    },
    showActionableTasksForCourse(course) {
      if (course.actionNeeded) {
        if (!this.selectedCourseId || this.selectedCourseId != course.courseId) {
          this.selectedCourseId = course.courseId;
        } else {
          this.selectedCourseId = null;
        }
      } else {
        this.selectedCourseHandler(course);
      }
    },
    handlePopupClose() {
      this.popupXBtnClicked = true;
    },
    closePopup() {
      this.quizViewIsActive = false;
      setTimeout(() => {
        this.$store.dispatch("updateTheme", "dark");
      }, 100);
    },
    getQuizTask(taskId,moduleId) {
      var self = this;
      self.popupXBtnClicked = false;
      self.quiz = {};
      self.showLoadingOnElement("whole_page", 1, "corners");

      var onSuccess = function (response) {
        self.quiz = response.data;
        self.quizViewIsActive = true;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(
        self,
        "Student/GetQuizTask?moduleId=" + moduleId + "&quizTaskId=" + taskId,
        onSuccess,
        onFinally
      );
    },
    selectedCourseHandler(courseData){
      var self = this;
      var selectedModule = {};
      if (!self.newUIProp) {
        selectedModule = self.allModules.filter(x=>x.moduleId == courseData.moduleId && !x.courseComplete)[0];
        setTimeout(() =>{
          self.continueModuleSelected(selectedModule)
        }, 5);
      } else {
        var onSuccess = function (response) {
          selectedModule = response.data;
          setTimeout(() =>{
            self.continueModuleSelected(selectedModule)
          }, 5);
        };
        var moduleInfo = selectedModule = self.progressPopupData.filter(x=>x.moduleId == courseData.moduleId && !x.courseComplete)[0];
        self.$ajaxGet(self, "Module/GetSingleModuleFromMenuData?moduleId=" + moduleInfo.moduleId + "&studentId=" + self.currentStudentId, onSuccess);
      }
    },
    openTaskAction(task){
      var self = this;
      let routeData = this.$router.resolve({ name: 'ViewAssessment', query: { TaskLogId: task.logId } });
      self.$emit("closeModuleProgressCallBack");
      window.open(routeData.href, '_blank');
    },
    continueModuleSelected(module) {
      var self = this;
      self.$emit("closeModuleProgressCallBack");
      self.isProfileSectionViewActive = false;
      self.isSelectModuleViewActive = false;
      self.selectedModule = module;
      setTimeout(() => {
        if(self.selectedModule.isLearningStyleB){
          if (self.newUIProp) {
            self.$router.push({ name: "Gen2LearningPrograms", params: { lp: {moduleId: self.selectedModule.moduleId, moduleName: self.selectedModule.moduleName, lpNumber: self.selectedModule.moduleNumber} } });
          } else {
            self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId: self.selectedModule.moduleId }});
          }
        }
        else{
          self.continueFrom(self.selectedModule.moduleId, self.selectedModule.taskDisplayId)
        }
      }, 5);
    },
    continueFrom(moduleId, taskDisplayId) {
      var self = this;
      
      if(moduleId && taskDisplayId){
        self.showLoadingOnElement('whole_page', 1, 'material');
        self.getCoins(moduleId, function() {
          localStorage.setItem("currentModule", moduleId);
          self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: taskDisplayId, moduleId: moduleId, isStudent: "true", coins: self.coins } });
        })
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    getCoins(moduleId, whenDone) {
      var self = this;

      var onSuccess = function (response) {
        self.coins = response.data;
        if (whenDone && typeof whenDone == "function")
          whenDone();
      };

      self.$ajaxGet(self, "CoinTransaction/GetCoins?studentId=" + self.currentStudentId + "&moduleId=" + moduleId, onSuccess);
    },
    showLogbookPreviewPopUp(logbookId){
      const self = this;
      self.selectedLogbook = logbookId;
      self.showLoadingOnElement('whole_page', 1, 'material');

      var onSuccess = function (response) {
        self.showLogbookPreview=true;
        self.$emit("closeModuleProgressCallBack");
        self.logbookHtml = response.data;
      };

      var onFinally = response =>{
        self.$vs.loading.close(self.$refs.whole_page.$el);
      }
      self.$ajaxGet(self, `Logbook/GenerateLogbookPreviewLogbookId?logbookId=${logbookId}`, onSuccess, onFinally);
    },
    approveLogbook() {
      const self = this;
      self.showLoadingOnElement("approve_logbook_btn", 0.45, "material");

      var onSuccess = function(response) {
        self.showLogbookPreview = false;
      };
      var onFinally = (response) => {
        if (self.$refs.approve_logbook_btn) {
          self.$vs.loading.close(self.$refs.approve_logbook_btn.$el);
        }
      };

      self.$ajaxGet(self, `Student/AcceptLogbook/${self.selectedLogbook}`, onSuccess, onFinally);
    },
    moduleListMethod(courseProgressStucture,course){
      return courseProgressStucture.filter(x=>x.courseId == course.courseId).map(x=> {return x.modules});
    },
    showAssessorFeedbackPopUp(feedbackId){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");

      var onSuccess = response =>{
        this.assessorFeedbackData = response.data;
        this.taskResults.fullname = response.data.learnerFullName;
        this.questionList = response.data.assessorFeedbackQuestionDTO;
        this.assessorFeedback = response.data.assessorFeedbackDTO;
        self.assessorfeedbackPopup = true;
        self.$emit("closeModuleProgressCallBack");
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `assessorFeedback/GetDetails/${feedbackId}` , onSuccess, onFinally);
    },
    htmlBuilderForassessorFeedbackDocumentQuestions(id){
      var self = this;
      self.selectedFeedbackId = id;
      var onSuccess = response =>{
        self.questionList = response.data;
        self.popupHtml = "";
        self.freeTextPopup = "";
        for (let index = 0; index < self.questionList.length -2; index++) {
          self.popupHtml += `
          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="Feedback${self.questionList[index].id}" name="${self.questionList[index].question}">
            <div class="state p-success">
              <label for="Feedback${self.questionList[index].id}">${self.questionList[index].question}</label><br>
            </div>
          </div>
          `;
          self.lastIndex = index;
        }
        for (let index = self.lastIndex+1; index < self.questionList.length ; index++) {
          self.freeTextPopup +=
          ` <div class=" mb-3">
              <div class="vs-component vs-con-textarea vs-textarea-primary" style="border: 1px solid rgba(0, 0, 0, 0.08);">
                  <label for="Feedback${self.questionList[index].id}">${self.questionList[index].question}</label><br>
                  <textarea id="Feedback${self.questionList[index].id}"  class="vs-textarea"></textarea> 
              </div>
            </div>`;
          
        }

        self.displayAssessmentQuestions();
      }

      self.$ajaxGet(self, "assessor/FeedbackDocumentQuestions" , onSuccess);
    },
    displayAssessmentQuestions(){
      var self = this;
      
      self.$swal({
        title: 'Feedback',
        icon: 'info',
        html: `
        <h4>Check the following</h4>
        <div class="popupCustomContent mb-3">
          ${self.popupHtml}
        </div>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
        },
        showClass: {
          popup: 'animate__animated animate__fadeInDown assessment-Questions',
        },
        confirmButtonText:'Next',
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
        showCancelButton:false,
        preConfirm:(data) =>{
          for (let index = 1; index < self.questionList.length -1; index++) {
            var generatedId = `Feedback${self.questionList[index-1].id}`
            var quizFeedback = document.getElementById(generatedId).checked;
            var thisAssessorFeedbackAnswer = {
              id:index,
              agree:quizFeedback,
              answer:null
            }
            this.assessorFeedback.assessorFeedbackAnswers.push(thisAssessorFeedbackAnswer);
          }
        },
      }).then((result) => {
        self.freeTextShowPopup();
      });
    },
    freeTextShowPopup(){
      var self = this;
      self.$swal({
        title: 'Feedback',
        icon: 'info',
        html: `
        <h4>Complete the following</h4>
        <div class="popupCustomContent mb-3">
          ${self.freeTextPopup}
        </div>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
        },
        showClass: {
          popup: 'animate__animated animate__fadeInDown assessment-Questions',
        },
        confirmButtonText:'Complete',
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
        showCancelButton:false,
        preConfirm:(data) =>{
          for (let index = self.lastIndex +1; index < self.questionList.length; index++) {
            var generatedId = `Feedback${self.questionList[index].id}`
            var quizFeedback = document.getElementById(generatedId).value;
            var thisAssessorFeedbackAnswer = {
              id:index +1,
              agree:null,
              answer:quizFeedback
            }
            this.assessorFeedback.assessorFeedbackAnswers.push(thisAssessorFeedbackAnswer);
          }
        },
      }).then((result) => {
        self.addStudentFeedback();
      });
    },
    addStudentFeedback(){
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');
      var onSuccess = response =>{
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
        self.showAssessorFeedbackPopUp(self.selectedFeedbackId);
      }
      var onFinally = response =>{
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
      self.assessorFeedback.Id = self.selectedFeedbackId;
      self.$ajaxPost(self, `assessor/FeedbackDocumentStudent/${self.selectedFeedbackId}` , self.assessorFeedback.assessorFeedbackAnswers , onSuccess, onFinally);
    },
    removeSelectedTask(temp){
    },
    goToTask(task){
      var self =this;
      var studentId = localStorage.getItem("Current_User_Id");
      if(task.taskTypeId == 9 ){
        self.$emit("closeModuleProgressCallBack");
        setTimeout(() => {
          self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: task.displayId, moduleId: task.moduleId, isStudent: "true", coins: self.coins , styleB: false,rewrite:true, taskClassificationTypeId: 9 } });
        }, 200);
      }else if(task.taskTypeId == 2){
          self.$router.push({ name: "VideoViewer", query: { id: task.taskId, moduleId: self.moduleId, styleB: true, taskClassificationTypeId: 9 }});
      }else if(task.taskTypeId == 5){
        self.$router.push({ name: "DocumentViewer", query: { id: task.taskId, moduleId: self.moduleId, styleB: true, taskClassificationTypeId: 9 }});
      }else if(task.taskTypeId == 4){
        self.$router.push({ name: "StoryViewer", params: { mode: "story", taskDisplayId: task.taskDisplayId, moduleId: self.moduleId, isStudent: "true", coins: self.coins , styleB: true, taskClassificationTypeId: 9 } });
      }else if(task.taskTypeId == 6){
        self.$router.push({ name: "UploadViewer", query: { 
          id: task.taskId, 
          rewrite:true,
          moduleId: self.moduleId, 
          styleB: true, 
          taskClassificationTypeId: 9,
          timeCapture: JSON.stringify(self.timeCapture)}});
      }else if(task.taskTypeId == 8){
        self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: task.taskDisplayId, moduleId: self.moduleId, isStudent: "false", coins: self.coins , styleB: true, taskClassificationTypeId: 9 } });
      }
    },
    brokenTasks(){
      var self = this;
      var onSuccess = response =>{
        self.brokenTaskList = response.data;
        self.brokenTaskList.forEach(element => {
          element.taskTypeId = 9
        });
      }
    
      var onFinally = response =>{
      }
    
      self.$ajaxGet(self, "Course/GetBrokenTasks" , onSuccess, onFinally);
    },
  },
  mounted(){
    
  },
}
</script>


<style lang="scss">
  @import "@/digicampus/assets/main-digi.scss";
#logbook-preview-popup {
  * {
    color: #000000 !important;
  }
  .vs-popup {
    height: fit-content !important;
    background: #ffffff !important;
    color: #000000 !important;

    .vs-popup--content {
      overflow-x: hidden !important;
    }

    .vs-popup--header {
      background: #d8d8d8 !important;

      .vs-popup--close--icon {
        background: rgb(255, 255, 255) !important;
        color: rgb(0, 0, 0) !important;
      }
    }
  }
}
  #DigiMenuPage{
    .alertDigi{
      height: unset !important;
    }
  }
  .key-items{
    margin-top: -15px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    span{
      padding: 0px 5px 0px 0px;
    }
  }
  .table_float_direction_progressDataList{
    text-align: center;
  }
  @media screen and (max-width:400px){
      .table_float_direction_progressDataList{
      text-align: left;
    }
  }
  .progressPopup{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
  
  .popupCustomContent{
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-top: 20px;
  }
  .assessment-Questions{
    width: fit-content;
  }
  
  #StudentModuleProgressPage{
    .vx-card__body{
      text-align:center !important
    }
  }
  .brokenTaskListRedo{
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    margin-bottom: 10px;
    .quesListBroken{
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: center;
    }
  }


</style>
